import { StubPage } from "~/pages/_shared/StubPage";

export function CertificatesPage() {
  return (
    <StubPage
      title="No certificates yet"
      description="Certificates are issued once an expedition is completed. They appear here for every crew member."
    />
  );
}
